/* eslint-disable vue/order-in-components */

import LinksFooter from '~/components/members-area/LinksFooter';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  layout(ctx) {
    if (ctx.route.query.token) return 'header-only';
    return 'empty';
  },
  components: {
    LoadingOverlay,
    LinksFooter
  },
  data() {
    return {
      settings: null,
      baseSettings: null,
      optout_marketing_comms: false,
      optout_rewards_store_comms: false,
      isUpdating: false,
      baseUrl: this.$config.apiBaseUrl,
      config: {},
      hasToken: false
    };
  },
  computed: {
    loading() {
      return this.isUpdating || !this.settings;
    },
    loadingReason() {
      if (this.isUpdating) return 'Updating your comms preferences...';
      return null;
    },
    hasUpdatedSettingsLocally() {
      return JSON.stringify(this.updatedSettings) !== this.baseSettings;
    },
    updatedSettings() {
      return {
        allow_marketing: !this.optout_marketing_comms,
        allow_rewards_store: !this.optout_rewards_store_comms
      };
    }
  },
  methods: {
    async loadSettings() {
      const settings = await this.$axios.$get(`${this.baseUrl}/users/me/comms/settings`, this.config);
      this.updateSettings(settings);
    },
    async saveSettings() {
      this.isUpdating = true;
      try {
        const settings = await this.$axios.$post(`${this.baseUrl}/users/me/comms/settings`, this.updatedSettings, this.config);
        this.updateSettings(settings);
      } catch (error) {
        alert(error);
      }
      this.isUpdating = false;
    },
    updateSettings(settings) {
      this.settings = settings;
      this.baseSettings = JSON.stringify(settings);
      this.optout_marketing_comms = !settings.allow_marketing;
      this.optout_rewards_store_comms = !settings.allow_rewards_store;
    }
  },
  async mounted() {
    const {
      token
    } = this.$route.query;
    if (!token) return;
    this.hasToken = !!token;
    this.config = {
      headers: {
        authorization: `Comms ${token}`
      }
    };
    await this.loadSettings();
  },
  head() {
    return {
      title: 'Comms Settings | Extra',
      meta: [{
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0'
      }]
    };
  }
};